import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ImageFillBackground extends BaseOption {
  static userInterfaceComponent = {
    label: "Fill Background",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        {
          id: "blur",
          name: "Blur",
        },
        {
          id: "whitespace",
          name: "Whitespace",
        },
        {
          id: "repeat",
          name: "Repeat",
        },
      ],
    },
  };

  static defaultValue = "whitespace";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "fill" || configValue === "blur-background") {
      return "blur";
    }
    if (configValue === "none" || configValue === "upscale") {
      return "whitespace";
    }
    return configValue;
  }
}
